import { render, staticRenderFns } from "./UpdatePatientModal.vue?vue&type=template&id=38d281a4&scoped=true"
import script from "./UpdatePatientModal.vue?vue&type=script&lang=ts"
export * from "./UpdatePatientModal.vue?vue&type=script&lang=ts"
import style0 from "./UpdatePatientModal.vue?vue&type=style&index=0&id=38d281a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d281a4",
  null
  
)

export default component.exports